import { render, staticRenderFns } from "./GasSensorListItem.vue?vue&type=template&id=15ca8c49&scoped=true&"
import script from "./GasSensorListItem.vue?vue&type=script&lang=ts&"
export * from "./GasSensorListItem.vue?vue&type=script&lang=ts&"
import style0 from "./GasSensorListItem.vue?vue&type=style&index=0&id=15ca8c49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca8c49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VExpansionPanel,VExpansionPanelContent,VImg})
